import { useGlobalContext } from '../GlobalContextProvider';
import { LoanFormatActionType, LoanFormatState } from './loanFormatReducer';
import { useCallback } from 'react';

export const useLoanFormat = () => {
    const { state, dispatch } = useGlobalContext();
    const loanFormat = state.loanFormat;

    const setLoanFormat = useCallback(
        (newLoanFormat: LoanFormatState) => {
            dispatch({ type: LoanFormatActionType.LOAN_FORMAT_CHANGE, loanFormat: newLoanFormat });
        },
        [dispatch]
    );

    return {
        loanFormat,
        setLoanFormat
    };
};
